import { Provider } from "./provider/Provider";

const UserService = {
  userLogin: ({ user, password, session }) => {
    return Provider({
      user: user,
      password: password,
      session: session,
      methodName: "Api/User/UserLogin"
    });
  },
  userList: () => {
    return Provider({
      methodName: "Api/User/UserList"
    });
  },
  userDetail: userId => {
    return Provider({
      userId: userId,
      methodName: "Api/User/UserDetail"
    });
  },
  newUser: ({ name, nickname, email, group, password, passwordAgain, params }) => {
    return Provider({
      name: name,
      nickName: nickname,
      email: email,
      password: password,
      passwordAgain: passwordAgain,
      group: group,
      params: params,
      methodName: "Api/User/NewUser"
    });
  },
  updateUser: ({ id, name, nickname, email, group, params }) => {
    return Provider({
      userID: id,
      name: name,
      nickName: nickname,
      email: email,
      group: group,
      params: params,
      methodName: "Api/User/UpdateUser"
    });
  },
  updatePassword: ({ id, password, passwordAgain }) => {
    return Provider({
      userID: id,
      passwordNew: password,
      passwordAgain: passwordAgain,
      methodName: "Api/User/UpdatePassword"
    });
  },
  deleteUser: userID => {
    return Provider({
      userID: userID,
      methodName: "Api/User/DeleteUser"
    });
  },
  userFields: () => {
    return Provider({
      methodName: "Api/User/UserFields"
    });
  },
  userGroups: () => {
    return Provider({
      methodName: "Api/User/UserGroups"
    });
  },
  addNewGroup: ({ groupName, groupDesc, rolesList }) => {
    return Provider({
      groupName: groupName,
      groupDesc: groupDesc,
      rolesList: rolesList,
      methodName: "Api/User/AddNewUserGroup"
    });
  },
  editUserGroup: ({ groupSysName, groupName, groupDesc, rolesList }) => {
    return Provider({
      groupSysName: groupSysName,
      groupName: groupName,
      groupDesc: groupDesc,
      rolesList: rolesList,
      methodName: "Api/User/EditUserGroup"
    });
  },
  deleteUserGroup: groupSysName => {
    return Provider({
      groupName: groupSysName,
      methodName: "Api/User/DeleteUserGroup"
    });
  },
  getGroupDetail: groupSysName => {
    return Provider({
      groupSysName: groupSysName,
      methodName: "Api/User/GroupDetail"
    });
  },
  addUserRole: ({ selectGroup, roleName, selectMethodsList }) => {
    return Provider({
      roleGroup: selectGroup,
      roleName: roleName,
      methodsList: selectMethodsList,
      methodName: "Api/User/AddUserRole"
    });
  },
  editRole: ({ editRoleID, selectGroup, roleName, selectMethodsList }) => {
    return Provider({
      roleID: editRoleID,
      roleGroup: selectGroup,
      roleName: roleName,
      methodsList: selectMethodsList,
      methodName: "Api/User/EditRole"
    });
  },
  addRoleGroup: ({ roleGroupName }) => {
    return Provider({
      roleGroupName: roleGroupName,
      methodName: "Api/User/AddRoleGroup"
    });
  },
  editRoleGroup: ({ roleGroupID, roleGroupName }) => {
    return Provider({
      roleGroupID: roleGroupID,
      roleGroupName: roleGroupName,
      methodName: "Api/User/EditRoleGroup"
    });
  },
  deleteRoleGroup: roleGroupID => {
    return Provider({
      roleGroupID,
      methodName: "Api/User/DeleteRoleGroup"
    });
  },
  getRolesList: () => {
    return Provider({
      methodName: "Api/User/GetRolesList"
    });
  },
  roleDetail: roleID => {
    return Provider({
      roleID: roleID,
      methodName: "Api/User/RoleDetail"
    });
  },
  getRolesGroups: () => {
    return Provider({
      methodName: "Api/User/RolesGroupsList"
    });
  },
  deleteRole: roleID => {
    return Provider({
      roleID: roleID,
      methodName: "Api/User/DeleteRole"
    });
  }
};

export default UserService;
